import { NotificationsService } from "@/services/notificationsApi";
import { NOTIFICATION_REDIRECTIONS } from "@/enums";
import vClickOutside from "v-click-outside";

export default {
	directives: {clickOutside: vClickOutside.directive},

	data() {
		return {
			loading: false,
			counter: null,
			visible: false,
			read: [],
			unread: [],
			limit: 10,
			offset: 0,
			loadMoreAvailable: true,
			// eslint-disable-next-line no-useless-escape
			urlRegex: /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/ig
		};
	},

	methods: {
		redirect,
		hideNotifications,
		loadMore,
		getRedirection,
		isValidUrl,
		toggle,
		resetNotifications,
		count,
		load
	},

	mounted() {
		this.count();
	}
};

function redirect(path) {
	const route = getRedirection(path);

	if (this.urlRegex.test(route))
		window.open(route, "_blank");
	else
		this.$router.push(route);


	this.hideNotifications();
}

function getRedirection(value) {
	return NOTIFICATION_REDIRECTIONS[value];
}

function isValidUrl(url) {
	return this.urlRegex.test(url);
}

async function toggle() {
	this.visible = !this.visible;

	if (this.visible) {
		this.loading = true;
		await this.count();
		this.load();
	}
	else {
		const DELAY = 500;

		setTimeout(() => {
			this.resetNotifications();
		}, DELAY);
	}
}

function hideNotifications() {
	this.visible = false;
	const DELAY = 500;

	setTimeout(() => {
		this.resetNotifications();
	}, DELAY);
}

async function resetNotifications() {

	const request = [];

	this.unread.forEach(item => {
		request.push(item.id);
	});

	if (request.length)
		await NotificationsService.setRead(request);


	/**
	 * reset everything and call count
	 * again to get unread count
	 */

	this.offset = 0;
	this.loadMoreAvailable = true;
	this.unread = [];
	this.read = [];
	this.counter = null;

	this.count();
}

async function count() {
	try {
		const { data } = await NotificationsService.count();

		this.counter = data.unread_count;
	}
	catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal"
		});
	}
}

function loadMore() {
	const OFFSET = 10;
	this.offset += OFFSET;

	this.load();
}

async function load() {
	try {
		const request = {
				limit: this.limit,
				offset: this.offset
			},
			{ data } = await NotificationsService.get(request);

		if (data.notifications.length) {
			if (data.notifications.length < this.limit)
				this.loadMoreAvailable = false;


			data.notifications.forEach(item => {
				if (item.is_read)
					this.read.push(item);
				else
					this.unread.push(item);

			});

			this.$forceUpdate();
		}
		else
			this.loadMoreAvailable = false;


		this.loading = false;
	}
	catch (error) {
		this.$swal({
			text: error.message,
			customClass: "swal_modal"
		});
	}
}
